import React, { Component } from "react";
import "./groupReport.css";
import GroupNav from "../DownloadReport/GroupNav";
import DatePicker from "react-datepicker";
import moment from "moment";
import ReportAPIs from "../../../../APIs/ReportAPIs";
import GroupTable from "./groupTable";
import momentTZ from "moment-timezone";
import Dom from "../../../../helpers/Dom";
import { processData as tripProcessData } from "../../../../Layouts/config/reports/tripReport";
import { processData as dailyProcessData } from "../../../../Layouts/config/reports/dailyReport";
import { processData as summaryProcessData } from "../../../../Layouts/config/reports/summaryReport";
import { isEvGroup } from "../../../../Layouts/config/reports/summaryReport";
import { dateFormat } from "../../../../constants/constants";
import actions from "../../../../store/actions";

class GroupReport extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      index: 0,
      reporttype: null,
      groups: [],
      selectedGroup: {},
      startDate: moment(Date.now()).startOf("day").subtract(1, "days").toDate(),
      endDate: moment().toDate(),
      tableData: [],
      selectedCols: [],
      selectedPage: 0,
      busy: false,
      showPagination: false,
      selectedReportData: {},
      errorPage: false,
    };
    this.reportName = ["trip_report", "daily_report", "summary_report"];
    this.tripHead = [
      { key: "vehicleno", name: "Vehicle No" },
      { key: "model", name: "Model" },
      { key: "starttime", name: "Start Time", type: "DATE" },
      { key: "endtime", name: "End Time", type: "DATE" },
      { key: "duration", name: "Duration" },
      { key: "distance", name: "Distance (km)" },
      { key: "startfl", name: "Start SOC" },
      { key: "endfl", name: "End SOC" },
      { key: "mileage", name: "Mileage (kmpl)" },
      { key: "avgspeed", name: "Avg Speed (kmph)" },
      {
        key: "startloc",
        name: "Start Location",
        onClick: (d, item) => {
          window.showInGoogleMaps(item.StartLatLng[0], item.StartLatLng[1]);
        },
      },
      {
        key: "endloc",
        name: "End Location",
        onClick: (d, item) => {
          window.showInGoogleMaps(item.EndLatLng[0], item.EndLatLng[1]);
        },
      },
    ];

    this.dailyHead = [
      { key: "vehicleno", name: "Vehicle No" },
      { key: "model", name: "Model" },
      {
        key: "starttime",
        name: "Start Time",
        type: "DATE",
        format: dateFormat,
      },
      { key: "endtime", name: "End Time", type: "DATE", format: dateFormat },
      { key: "distance", name: "Distance (km)" },
      {
        key: "startfl",
        name: "Start SOC",
        isShowable: (item) => isEvGroup(item),
      },
      { key: "endfl", name: "End SOC", isShowable: (item) => isEvGroup(item) },
      { key: "avgspeed", name: "Avg Speed (kmph)" },
      {
        key: "idlingtime",
        name: "Idling Time (min)",
        isShowable: (item, props, head) => !isEvGroup(item),
      },
      {
        key: "startloc",
        name: "Start Location",
        onClick: (d, item) => {
          window.showInGoogleMaps(item.StartLatLng[0], item.StartLatLng[1]);
        },
      },
      {
        key: "endloc",
        name: "End Location",
        onClick: (d, item) => {
          window.showInGoogleMaps(item.EndLatLng[0], item.EndLatLng[1]);
        },
      },
    ];

    this.summaryHead = [
      { key: "vehicleno", name: "", name: "Vehicle No" },
      { key: "model", name: "Model" },
      {
        key: "starttime",
        name: "Start Time",
        type: "DATE",
        format: dateFormat,
      },
      {
        key: "endtime",
        name: "End Time",
        type: "DATE",
        format: dateFormat,
      },
      { key: "distance", name: "Distance (km)" },
      { key: "startfl", name: "Start SOC" },
      { key: "endfl", name: "End SOC" },
      { key: "avgspeed", name: "Avg Speed (kmph)" },
      { key: "idlingtime", name: "Idling Time (min)" },
      {
        key: "startodo",
        name: "Start Odo (km)",
        isShowable: (item) => !isEvGroup(item),
      },
      {
        key: "endodo",
        name: "End Odo (km)",
        isShowable: (item) => !isEvGroup(item),
      },
      {
        key: "startloc",
        name: "Start Location",
        width: 2,
        onClick: (d, item) => {
          window.showInGoogleMaps(item.StartLatLng[0], item.StartLatLng[1]);
        },
      },
      {
        key: "endloc",
        name: "End Location",
        width: 2,
        onClick: (d, item) => {
          window.showInGoogleMaps(item.EndLatLng[0], item.EndLatLng[1]);
        },
      },
    ];
  }

  getReportType = () => {
    return this.props.allowedReports.map((report, index) => {
      if (this.reportName.includes(report.key))
        return (
          <option key={index} value={report.key}>
            {report.name}
          </option>
        );
    });
  };

  navigate = (group) => {
    let rootGroupPath = "";
    let path = group.path;
    let pathArray = path.split("/");
    pathArray.splice(0, 1);
    pathArray = pathArray.splice(0, pathArray.length - 1);
    let currentPath = rootGroupPath;
    let nav = [];
    let currentNode = this.group;
    nav.push(currentNode);
    for (let idx in pathArray) {
      currentPath += "/" + pathArray[idx];
      for (let jdx in currentNode.children) {
        if (currentNode.children[jdx].path === currentPath + "/") {
          currentNode = currentNode.children[jdx];
          if (!("children" in currentNode)) currentNode.children = [];
          nav.push(currentNode);
          break;
        }
      }
    }
    if (this.state.selectedGroup && group) {
      if (this.state.selectedGroup.groupid !== group.groupid) {
        // this.allIntervals.forEach(clearInterval);
      }
    }
    this.setState({ groups: nav, selectedGroup: group }, () => {});
  };

  preProcessData = (respObj) => {
    let oldrespObj = {};
    for (let idx in respObj) {
      let item = respObj[idx];
      if (!(item.vehicleid in oldrespObj)) {
        oldrespObj[item.vehicleid] = [];
      }
      oldrespObj[item.vehicleid].push(item);
    }

    return oldrespObj;
  };

  fetchData = () => {
    let starttime = moment(this.state.startDate).unix() * 1000;
    let endtime = moment(this.state.endDate).unix() * 1000;
    let body = {
      starttime: starttime,
      endtime: endtime,
      vehicleid: this.state.splitedVehicles[this.state.selectedPage],
    };
    if (window.showNoGpsFixData === true) {
      body.fixqfilter = false;
    }

    if (this.state.reporttype === "trip_report") {
      ReportAPIs.getPrecomputeTrips(body)
        .then((resp) => {
          let preProcessed = this.preProcessData(resp);
          let noFilter = false;
          tripProcessData(
            preProcessed,
            window.vehicleMap,
            (data) => {
              let selectedReportData = { ...this.state.selectedReportData };
              selectedReportData[this.state.selectedPage] = data;

              this.setState({
                tableData: data,
                busy: false,
                showPagination: true,
                selectedReportData: selectedReportData,
              });
            },
            noFilter
          );
        })
        .catch((e) => {
          console.log(e);
          this.setState({ busy: false,errorPage: true });
        });
    } else if (this.state.reporttype === "daily_report") {
      body.tzoffset = momentTZ().utcOffset() * 60;

      ReportAPIs.getPrecomputeDailytrips(body)
        .then((resp) => {
          dailyProcessData(resp, window.vehicleMap, (data) => {
            let selectedReportData = { ...this.state.selectedReportData };
            selectedReportData[this.state.selectedPage] = data;
            this.setState({
              tableData: data,
              busy: false,
              showPagination: true,
              selectedReportData: selectedReportData,
            });
          });
        })
        .catch((e) => {
          console.log(e);
          this.setState({ busy: false,errorPage:true });
        });
    } else if (this.state.reporttype === "summary_report") {
      ReportAPIs.getPrecomputeSummarytrips(body)
        .then((resp) => {
          summaryProcessData(resp, window.vehicleMap, (data) => {
            let selectedReportData = { ...this.state.selectedReportData };
            selectedReportData[this.state.selectedPage] = data;
            this.setState({
              tableData: data,
              busy: false,
              showPagination: true,
              selectedReportData: selectedReportData,
              errorPage: true,
            });
          });
        })
        .catch((e) => {
          console.log(e);
          this.setState({ busy: false, errorPage:true });
        });
    }
  };

  getReportApi = () => {
    if (
      this.state.selectedGroup.vehicles === undefined ||
      this.state.selectedGroup.vehicles.length === 0
    ) {
      this.setState({ busy: false });
      this.props.props.dispatch({
        type: actions.ADD_INTOAST,
        data: {
          name: "No Vehicle In The Group",
          content: "No vehilce in the selected group",
          createAt: Date.now(),
          autoClose: 8000,
        },
      });
      return;
    }

    let starttime = moment(this.state.startDate).unix() * 1000;
    let endtime = moment(this.state.endDate).unix() * 1000;
    let days = endtime - starttime;
    this.count = 0;
    let fixedQueryLimit = 700;
    let splitedVehicles = [];
    let filteredVehicles = [];
    days = Math.ceil(days / 86400000); //total days
    let queryLimit = this.state.selectedGroup.vehicles.length * days * 10; // total query limit
    this.count = Math.ceil(queryLimit / fixedQueryLimit); // page number
    this.splitCount = parseInt(
      this.state.selectedGroup.vehicles.length / this.count
    ); // total vehicle / total pages
    if (this.splitCount > 50) this.splitCount = 50;
    let vehicleids = this.state.selectedGroup.vehicles.map((vehicle) => {
      return vehicle.vehicleid;
    });

    let getReportBody = {
      starttime: starttime,
      endtime: endtime,
      vehicle: vehicleids || [],
    };
    ReportAPIs.getReportVehicles(getReportBody).then((resp) => {
      filteredVehicles = resp;

      let startIndex = 0;
      let endIndex = this.splitCount;
      for (let pages = 0; pages < this.count; pages++) {
        let page = [];
        for (let idx in filteredVehicles) {
          if (idx >= startIndex && idx <= filteredVehicles.length) {
            if (idx <= endIndex - 1) page.push(filteredVehicles[idx]);
          }
        }
        splitedVehicles.push(page);
        startIndex = endIndex;
        endIndex = startIndex + this.splitCount;
        if (pages === this.count - 1 && startIndex <= filteredVehicles.length) {
          if (filteredVehicles.length - startIndex > 0) {
            this.count++;
          }
        }
      }
      this.setState({ splitedVehicles: splitedVehicles }, () => {
        this.fetchData();
      });
    });
  };

  getReportData = () => {
    if (!this.state.reporttype) {
      this.props.props.dispatch({
        type: actions.ADD_INTOAST,
        data: {
          name: "Please select a report",
          content: "Please select a report",
          createAt: Date.now(),
          autoClose: 8000,
        },
      });
      return;
    }
    this.setState({
      tableData: [],
      busy: true,
      selectedReportData: {},
      selectedPage: 0,
      showPagination: false,
      errorPage: false,
    });
    this.getReportApi();
  };

  handleStartDate = (date) => {
    this.setState({ startDate: date });
  };

  handleEndDate = (date) => {
    this.setState({ endDate: date });
  };

  changePage = (page) => {
    this.setState({ selectedPage: page, tableData: [], busy: true, errorPage:false }, () => {
      if (
        this.state.selectedReportData[page] &&
        this.state.selectedReportData[page].length
      ) {
        this.setState({
          tableData: this.state.selectedReportData[page],
          busy: false,
        });
      } else {
        this.fetchData();
      }
    });
  };
  getPagination() {
    let pag = [];

    let itemWidth = 40;
    let containerWidth = this.props.data._position.width - 208;
    let itemAllowed = containerWidth / itemWidth;
    // let count = Math.ceil(this.state.filtered.length / this.state.limit);

    let count = this.count;
    this.splitCount;

    if (count <= itemAllowed) {
      for (let idx = 0; idx < count; idx++) {
        pag.push(idx);
      }
      return pag;
    }

    let mid = Math.ceil(this.state.index - itemAllowed / 2);
    mid = Math.max(0, Math.min(mid, count - Math.floor(itemAllowed)));

    for (let idx = mid + 1; idx < mid + itemAllowed - 2; idx++) {
      pag.push(idx);
    }

    pag = [0, ...pag, count - 1];

    return pag;
  }
  selectReport = (e) => {
    let reporttype = e.target.value;
    this.setState({
      reporttype: reporttype,
      requestSend: false,
      tableData: [],
      selectedPage: 0,
      showPagination: false,
      selectedReportData: {},
    });
    if (reporttype === "trip_report") {
      this.setState({ selectedCols: this.tripHead });
    } else if (reporttype === "daily_report") {
      this.setState({ selectedCols: this.dailyHead });
    } else if (reporttype === "summary_report") {
      this.setState({ selectedCols: this.summaryHead });
    }
  };

  componentDidMount() {
    let group = this.props.props.groupTree;
    if (!group.path) {
      group.path = "/0/";
      group.ppath = "/0/";
    }
    this.group = group;
    this.setState({ groups: group }, () => {
      this.navigate(group);
    });
  }

  render() {
    return (
      <div className="group-main-container">
        <div className="group-container">
          <div className="groupNav">
            <GroupNav props={this.state} navigate={this.navigate} />
          </div>
          <div className="report-section">
            <div className="report-selection">
              <select
                onChange={(e) => {
                  this.selectReport(e);
                }}
              >
                <option value={null}>Select Report</option>
                {this.getReportType()}
              </select>
            </div>
            <div className="date-section">
              <div className="ds-picker">

                <DatePicker
                  wrapperClassName="datepicker"
                  selected={this.state.startDate}
                  onChange={(e) => this.handleStartDate(e)}
                  dateFormat="dd-MM-yyyy"
                  maxDate= {moment(Date.now()).startOf("day").subtract(0, "days").toDate()}
                  
                />
              </div>
              <div className="ds-picker">
                <DatePicker
                  wrapperClassName="datepicker"
                  selected={this.state.endDate}
                  onChange={(e) => this.handleEndDate(e)}
                  dateFormat="dd-MM-yyyy"
                  maxDate= {moment(Date.now()).startOf("day").subtract(0, "days").toDate()}
                  
                />
              </div>
            </div>
            <div className="report-btn" onClick={() => this.getReportData()}>
              Get Report
            </div>
          </div>
          <div className="table-section">
            <div className="group-table">
              <GroupTable
                data={this.state.tableData}
                columns={this.state.selectedCols}
              />
              {this.state.busy ? (
                <div className="table-loader">
                  <div className="loading"></div>
                </div>
              ) : null}
              {this.state.errorPage ? (
                <div className="error-page">
                  <div>NO DATA</div>
                </div>
              ) : null}
            </div>

            {this.state.showPagination ? (
              <div className="it-pagination">
                {this.getPagination().map((item, index) => {
                  return (
                    <div className="itp-item" key={index}>
                      <div
                        className={Dom.Class(
                          { active: item === this.state.selectedPage },
                          "itpi-name"
                        )}
                        onClick={() => this.changePage(item)}
                      >
                        {item + 1}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default GroupReport;
